import { AgxCommissionHistoryView, AgxModal, AgxSpacer } from '@urbanx/agx.ui-components2';
import { type CommissionInformation } from '@urbanx/agx.campaigns.client';

const CommissionHistoryModal = ({
  onClose,
  commission,
}: {
  onClose: () => void;
  commission?: CommissionInformation;
}) => {
  if (!commission) return null;

  return (
    <AgxModal
      title={'Commission History'}
      type="single"
      variant={'withDivider'}
      actionButtonContainerStyle={'withoutDivider'}
      content={
        <AgxSpacer padding="xl">
          <AgxCommissionHistoryView commission={commission} />
        </AgxSpacer>
      }
      setIsDialogOpen={onClose}
    />
  );
};

export default CommissionHistoryModal;
